import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, GridItem, Grid, Link, Button } from "@chakra-ui/react";
import moment from "moment";
import { BsChevronRight } from "react-icons/bs";

const Transactions = ({ txHistory }) => {
  /*   const options = { method: "GET" };

  fetch(
    `https://api.mobula.io/api/1/wallet/transactions?wallet=${info}&blockchains=Solana`,
    options
  )
    .then((response) => response.json())
    .then((response) => console.log(response?.data?.transactions))
    .catch((err) => console.error(err)); */

  /*   let url = `https://api.helius.xyz/v0/addresses/${info}/transactions?api-key=${process.env.REACT_APP_HELIUS_KEY}`;
  let lastSignature = null;

  const fetchAndParseTransactions = async () => {
    try {
      while (true) {
        if (lastSignature) {
          url += `&before=${lastSignature}`;
        }
        const response = await fetch(url);
        const transactions = await response.json();

        if (transactions && transactions.length > 0) {
          setTxHistory(transactions);
          lastSignature = transactions[transactions.length - 1].signature;
        } else {
          break;
        }
      }
    } catch (e) {}
  }; */

  /*   useEffect(() => {
    try {
      fetchAndParseTransactions();
    } catch (e) {}
  }, [info]); */

  function extractText(inputText, identifier) {
    // Find the index where the identifier starts in the input text
    const startIndex = inputText.indexOf(identifier);

    // Add the length of the identifier to get the start index of the desired text
    const desiredText = inputText
      .substring(startIndex + identifier.length)
      .trim();

    return desiredText;
  }

  return (
    <div>
      {/*  <Button onClick={() => fetchData()}>hi</Button> */}
      {Array.isArray(txHistory) &&
        txHistory?.map((e, i) => {
          if (String(e?.description) !== "") {
            return (
              <>
                <Link
                  isExternal
                  href={`https://solscan.io/tx/${e?.signature}`}
                  _hover={{ textDecoration: "none" }}
                >
                  <Box
                    mt="10px"
                    w="100%"
                    p="15px"
                    borderRadius="10px"
                    bg="#15161a"
                    overflow="auto"
                    key={i}
                  >
                    <Flex
                      w="100%"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      {" "}
                      <Box>
                        {" "}
                        <Box fontSize="10px" color="gray.500">
                          {moment
                            .unix(e?.timestamp)
                            .format("ddd, MMM Do YYYY, h:mm:ss A")}
                        </Box>
                        <Box>{extractText(e?.description, e?.feePayer)}</Box>
                      </Box>
                      <Box>
                        <BsChevronRight size="10px" />
                      </Box>
                    </Flex>
                  </Box>
                </Link>
              </>
            );
          }
        })}
    </div>
  );
};

export default Transactions;
